import ModularOutdoorSofas from "@inter-ikea-range/modular-outdoor-sofas";
import OutdoorExperience from "@inter-ikea-range/outdoor-experience";
import OutdoorKitchen from "@inter-ikea-range/outdoor-kitchen";
import OutdoorSeating from "@inter-ikea-range/outdoor-seating";
import OutdoorStorage from "@inter-ikea-range/outdoor-storage";
import OutdoorTables from "@inter-ikea-range/outdoor-tables";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";
import { ModularOutdoorSofaBuildMode } from "@inter-ikea-space-platform/range";

// room experience
export const outdoorExperience = (settings: EnvironmentSettings) => OutdoorExperience(settings);

// range packages
export const outdoorPackages = (settings: EnvironmentSettings): Experience[] => {
  const packages = [
    ModularOutdoorSofas(settings),
    ModularOutdoorSofaBuildMode(),
    OutdoorKitchen(settings),
    OutdoorSeating(settings),
    OutdoorStorage(settings),
    OutdoorTables(settings),
  ];
  return packages;
};
